// TODO: I need better names.
module.exports = {
  scene: require('./scene'),

  Points: require('./Points'),
  Point: require('./Point'),
  
  Lines: require('./lines/Lines'),
  Wires: require('./lines/Wires'),

  Element: require('./Element'),
}


// WEBPACK FOOTER //
// ./src/lib/wgl/index.js